<template>
  <vs-popup class="raw-material-stock-popup"
            title="ADJUST FINISHED PRODUCT STOCK"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="popup" @submit.prevent="handleSubmit(onClickUpdateStockLevel)" autocomplete="off">

             <div class="vx-row mb-3 mt-2" v-if="stock_status !=='In-Dispatch'">
              <div class="vx-col md:w-full md:mb-0">
                <ValidationProvider vid="current_stock_level" name="current_stock_level" rules="required" v-slot="{ errors }">
                  <small class="label">Current Stock Level</small>
                  <vs-input v-model="createForm.current_stock_level"  name="current_stock_level" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3 mt-2">
              <div class="vx-col md:w-1/2 md:mb-0">
                <ValidationProvider vid="manufacture_date" name="manufacture_date" rules="required" v-slot="{ errors }">
                  <small class="label">Manufacture Date</small>
                  <flat-pickr
                    :config="{ dateFormat: 'd/m/Y'}"
                    v-model="createForm.manufacture_date"
                    placeholder="Choose Date" class="hidden"/>
                  <flat-pickr
                    :config="{ dateFormat: 'd/m/Y'}"
                    v-model="createForm.manufacture_date"
                    placeholder="Choose Date" class="w-full"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 md:mb-0">
                <ValidationProvider vid="expiration_date" name="expiration_date" rules="required" v-slot="{ errors }">
                  <small class="label">Expiration Date</small>
                  <flat-pickr
                    :config="{ dateFormat: 'd/m/Y'}"
                    v-model="createForm.expiration_date"
                    placeholder="Choose Date" class="hidden"/>
                  <flat-pickr
                    :config="{ dateFormat: 'd/m/Y'}"
                    v-model="createForm.expiration_date"
                    placeholder="Choose Date" class="w-full"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3 mt-2" >
              <div class="vx-col md:w-full md:mb-0">
                <ValidationProvider vid="reason" name="reason" rules="required" v-slot="{ errors }">
                  <small class="label">Reason</small>
                  <v-select  :clearable="true" name="reason" placeholder="" v-model="createForm.reason" :options="reasons" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row mb-3 mt-2" v-if="createForm.reason === 'Other'">
              <div class="vx-col md:w-full md:mb-0">
                <ValidationProvider vid="other_reason" name="other_reason" rules="required" v-slot="{ errors }">
                  <small class="label">Other Reason</small>
                  <vs-input v-model="createForm.other_reason"  name="other_reason" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>

            <div class="flex flex-wrap items-center justify-end mt-8" >
              <vs-button id="save_change_button" button="submit" class="ml-auto mt-2">Save changes</vs-button>
              <vs-button @click="open =false" class="ml-4 mt-2" type="border" color="warning">Cancel</vs-button>
            </div>

        </form>
      </ValidationObserver>

    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import FormulationStockInventory
    from "@/views/pages/manufacturing/formulation-stock/FormulationStockInventory";

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      id: '',
      createForm: {current_stock_level: '', manufacture_date: '', expiration_date: ''},
      current_stock_level: '',
      is_on_update: false,
      reasons: ['Assigned to NPD', 'Product Loss - Human error', 'Product Loss - Multiple weigh out', 'Sample to QC', 'Stock check  - manual adjustment', 'Other'],
      stock_status: '',
      form_data: {}
    }
  }

export default {
  name: 'AdjustProductStockPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (data) {
      try {
        Object.assign(this.$data, initialState())
        Object.assign(this.form_data, data)
        this.createForm = {  }
        this.createForm.current_stock_level = this.form_data.completed_quantity
        this.createForm.manufacture_date = this.form_data.manufacture_date
        this.createForm.expiration_date = this.form_data.expiration_date
        this.stock_status = this.form_data.status
        this.open = true;
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },

    async onClickUpdateStockLevel (){
      const vue = this
      await this.$vs.loading({
        container: '#save_change_button',
        scale: 0.45
      })
       try {
         let current_stock_level = Number(this.createForm.current_stock_level).toFixed(4)
         const payload = {
           completed_quantity: current_stock_level,
           reason_for_change: this.createForm.reason !== 'Other' ? this.createForm.reason :  this.createForm.other_reason,
           manufacture_date:  this.createForm.manufacture_date,
           expiration_date: this.createForm.expiration_date
         }
         await ManufacturingRepository.updateFormulationStockInventory(this.form_data.id, payload)
         this.showSuccessMessage('Stock level updated successfully')
         this.open = false;
         await vue.$parent.refreshData()
         this.$vs.loading.close('#save_change_button > .con-vs-loading')
       }catch (e) {
         this.$vs.loading.close('#save_change_button > .con-vs-loading')
         this.convertAndNotifyError(e)
       }
    },
    toFixed(number) {
      return Number(number).toFixed(3)
    }

  },
  components: {
    'v-select': vSelect,
    FormulationStockInventory,
    flatPickr,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .raw-material-stock-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 40% !important;
  }

</style>
